module.exports = __webpack_public_path__ + "img/jishudefen.66114610.svg";